export const operator_options = {
  content: [
    { label: "equal", value: "equal" },
    { label: "not equal", value: "not_equal" },
  ],
  status: [
    { label: "is", value: "is" },
    { label: "is not", value: "is_not" },
  ],
}

export const field_matchType = [
  { label: "any", value: "any" },
  { label: "all", value: "all" },
]

export const field_options = [
  { label: "content", value: "content" },
  { label: "status", value: "status" },
]

export const status_options = [
  { label: "pending", value: "pending" },
  { label: "extracted", value: "extracted" },
  { label: "failed", value: "failed" },
  { label: "draft", value: "draft" },
]
